// autofinance_summary_ui_v1: หน้าสรุปการเงิน (รวมทุกธุรกิจ / แยกธุรกิจ / แยกบัญชี) + กราฟ
import React, { useState, useEffect } from 'react';
import API from '../api';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, PieChart, Pie, Cell } from 'recharts';

const S = '/api/finance/summary';
const FB = '/api/finance/businesses';
const money = function (n) { return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
const card = { background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };
const PIE_COLORS = ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316', '#6366f1', '#84cc16'];
// autofinance_datefilter_ui_v1: helper + ตัวกรองวันที่
function buildQS(from, to) { var p = []; if (from) p.push('from=' + encodeURIComponent(from)); if (to) p.push('to=' + encodeURIComponent(to + 'T23:59:59')); return p.length ? ('?' + p.join('&')) : ''; }
function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
function DateFilter(props) {
  var preset = function (key) {
    var now = new Date(); var from = null, to = null;
    if (key === 'today') { from = ymd(now); to = ymd(now); }
    else if (key === '7d') { var d = new Date(now); d.setDate(d.getDate() - 6); from = ymd(d); to = ymd(now); }
    else if (key === 'month') { from = ymd(new Date(now.getFullYear(), now.getMonth(), 1)); to = ymd(now); }
    else if (key === 'year') { from = ymd(new Date(now.getFullYear(), 0, 1)); to = ymd(now); }
    props.onChange(from, to);
  };
  var btn = function (key, label) {
    return React.createElement('button', { key: key, onClick: function () { preset(key); }, style: { padding: '6px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer', fontSize: 12 } }, label);
  };
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
      <span style={{ fontSize: 12, color: '#64748b', fontWeight: 600 }}>ช่วงวันที่:</span>
      {[['all', 'ทั้งหมด'], ['today', 'วันนี้'], ['7d', '7 วัน'], ['month', 'เดือนนี้'], ['year', 'ปีนี้']].map(function (p) {
        return p[0] === 'all'
          ? React.createElement('button', { key: 'all', onClick: function () { props.onChange(null, null); }, style: { padding: '6px 12px', borderRadius: 8, border: (!props.from && !props.to) ? '2px solid #10b981' : '1px solid #e2e8f0', background: (!props.from && !props.to) ? '#ecfdf5' : '#fff', color: (!props.from && !props.to) ? '#10b981' : '#475569', cursor: 'pointer', fontSize: 12, fontWeight: 600 } }, 'ทั้งหมด')
          : btn(p[0], p[1]);
      })}
      <input type="date" value={props.from || ''} onChange={function (e) { props.onChange(e.target.value || null, props.to); }} style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }} />
      <span style={{ fontSize: 12, color: '#94a3b8' }}>ถึง</span>
      <input type="date" value={props.to || ''} onChange={function (e) { props.onChange(props.from, e.target.value || null); }} style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }} />
    </div>
  );
}


function Cards(props) {
  var d = props.data || {};
  var items = [['รายรับรวม', d.income, '#10b981'], ['รายจ่ายรวม', d.expense, '#ef4444'], ['คงเหลือ', d.balance, (d.balance >= 0 ? '#10b981' : '#ef4444')], ['จำนวนรายการ', d.count, '#0f172a']];
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 16 }}>
      {items.map(function (it, i) {
        return <div key={i} style={card}><div style={{ fontSize: 12, color: '#64748b' }}>{it[0]}</div><div style={{ fontSize: 22, fontWeight: 700, color: it[2] }}>{i === 3 ? it[1] : money(it[1])}</div></div>;
      })}
    </div>
  );
}

export default function BillFinanceSummary() {
  const [view, setView] = useState('all');
  const [bizList, setBizList] = useState([]);
  const [bizId, setBizId] = useState('');
  const [loading, setLoading] = useState(true);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const qs = buildQS(from, to);
  const onDate = function (f, t) { setFrom(f); setTo(t); };

  useEffect(function () {
    API.get(FB).then(function (r) {
      var list = r.data || [];
      setBizList(list);
      if (!bizId && list.length) setBizId(list[0].id);
    }).catch(function () {}).finally(function () { setLoading(false); });
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 16px', color: '#0f172a' }}>📊 สรุปการเงิน</h1>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['all', 'รวมทุกธุรกิจ'], ['biz', 'แยกธุรกิจ'], ['acc', 'แยกบัญชี'], ['reconcile', 'ตรวจยอด']].map(function (t) {
          return <button key={t[0]} onClick={function () { setView(t[0]); }}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, background: view === t[0] ? '#10b981' : '#f1f5f9', color: view === t[0] ? '#fff' : '#475569' }}>{t[1]}</button>;
        })}
        {(view === 'biz' || view === 'acc') && (
          <select value={bizId} onChange={function (e) { setBizId(e.target.value); }} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, minWidth: 150 }}>
            {bizList.map(function (b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
          </select>
        )}
      </div>

      <DateFilter from={from} to={to} onChange={onDate} />
      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>
        : view === 'all' ? <AllView qs={qs} />
        : view === 'biz' ? <BizView bizId={bizId} qs={qs} />
        : view === 'reconcile' ? <ReconcileView />/* finance_reconcile_v1 */
        : <AccView bizId={bizId} qs={qs} />}
    </div>
  );
}

// ===== รวมทุกธุรกิจ =====
function AllView(props) {
  const [data, setData] = useState(null);
  useEffect(function () {
    API.get(S + '/overview' + (props.qs || '')).then(function (r) { setData(r.data); }).catch(function () { setData(null); });
  }, [props.qs]);
  if (!data) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;
  var chartData = (data.businesses || []).map(function (b) { return { name: b.name, รายรับ: b.income, รายจ่าย: b.expense }; });
  var pieData = (data.businesses || []).filter(function (b) { return b.balance > 0; }).map(function (b) { return { name: b.name, value: b.balance }; });

  return (
    <div>
      <Cards data={data.total} />
      {chartData.length > 0 && (
        <div style={Object.assign({}, card, { marginBottom: 16 })}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#0f172a' }}>รายรับ-รายจ่าย แยกตามธุรกิจ</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={chartData} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} formatter={function (v) { return money(v); }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="รายรับ" fill="#10b981" radius={[4, 4, 0, 0]} />
              <Bar dataKey="รายจ่าย" fill="#ef4444" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
      {pieData.length > 0 && (
        <div style={Object.assign({}, card, { marginBottom: 16 })}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#0f172a' }}>สัดส่วนคงเหลือ (เฉพาะธุรกิจที่กำไร)</div>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label={function (e) { return e.name; }}>
                {pieData.map(function (e, i) { return <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />; })}
              </Pie>
              <Tooltip formatter={function (v) { return money(v); }} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
      <PivotTable title="ตารางสรุปรายธุรกิจ" rows={data.businesses} labelKey="name" />
    </div>
  );
}

// ===== แยกธุรกิจ (pivot category) =====
function BizView(props) {
  const [data, setData] = useState(null);
  useEffect(function () {
    if (!props.bizId) return;
    setData(null);
    API.get(S + '/by-business/' + props.bizId + (props.qs || '')).then(function (r) { setData(r.data); }).catch(function () { setData(null); });
  }, [props.bizId, props.qs]);
  if (!props.bizId) return <div style={Object.assign({}, card, { textAlign: 'center', color: '#94a3b8' })}>เลือกธุรกิจ</div>;
  if (!data) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;
  var chartData = (data.rows || []).map(function (r) { return { name: r.category, รายรับ: r.income, รายจ่าย: r.expense }; });
  var totalIncome = 0, totalExpense = 0;
  (data.rows || []).forEach(function (r) { totalIncome += r.income; totalExpense += r.expense; });

  return (
    <div>
      <Cards data={{ income: totalIncome, expense: totalExpense, balance: Number((totalIncome - totalExpense).toFixed(2)), count: (data.rows || []).reduce(function (s, r) { return s + r.count; }, 0) }} />
      {chartData.length > 0 && (
        <div style={Object.assign({}, card, { marginBottom: 16 })}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#0f172a' }}>รายรับ-รายจ่าย แยกตามรายการ — {data.business.name}</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={chartData} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} formatter={function (v) { return money(v); }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="รายรับ" fill="#10b981" radius={[4, 4, 0, 0]} />
              <Bar dataKey="รายจ่าย" fill="#ef4444" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
      <PivotTable title="ตาราง pivot ตามรายการ" rows={data.rows} labelKey="category" />
    </div>
  );
}

// ===== แยกบัญชี =====
function AccView(props) {
  const [data, setData] = useState(null);
  useEffect(function () {
    if (!props.bizId) return;
    setData(null);
    API.get(S + '/by-account/' + props.bizId + (props.qs || '')).then(function (r) { setData(r.data); }).catch(function () { setData(null); });
  }, [props.bizId, props.qs]);
  if (!props.bizId) return <div style={Object.assign({}, card, { textAlign: 'center', color: '#94a3b8' })}>เลือกธุรกิจ</div>;
  if (!data) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;
  var chartData = (data.rows || []).map(function (r) { return { name: r.label, รายรับ: r.income, รายจ่าย: r.expense }; });
  var totalIncome = 0, totalExpense = 0;
  (data.rows || []).forEach(function (r) { totalIncome += r.income; totalExpense += r.expense; });

  return (
    <div>
      <Cards data={{ income: totalIncome, expense: totalExpense, balance: Number((totalIncome - totalExpense).toFixed(2)), count: (data.rows || []).reduce(function (s, r) { return s + r.count; }, 0) }} />
      {chartData.length > 0 && (
        <div style={Object.assign({}, card, { marginBottom: 16 })}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#0f172a' }}>รายรับ-รายจ่าย แยกตามบัญชี — {data.business.name}</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={chartData} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} formatter={function (v) { return money(v); }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="รายรับ" fill="#10b981" radius={[4, 4, 0, 0]} />
              <Bar dataKey="รายจ่าย" fill="#ef4444" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
      <PivotTable title="ตารางสรุปรายบัญชี" rows={data.rows} labelKey="label" />
    </div>
  );
}

/* finance_reconcile_v1: ตรวจยอด diff */
function ReconcileView() {
  const [data, setData] = useState(null);
  function load() {
    setData(null);
    API.get(S + '/reconcile').then(function (r) { setData(r.data); }).catch(function () { setData({ accounts: [] }); });
  }
  useEffect(load, []);
  function setStatement(acc) {
    var cur = acc.statement_balance === null ? '' : String(acc.statement_balance);
    var v = window.prompt('กรอกยอดจริงในธนาคารของบัญชี "' + acc.label + '" (บาท)', cur);
    if (v === null) return;
    if (isNaN(Number(v))) { alert('ต้องเป็นตัวเลข'); return; }
    API.patch(S + '/reconcile/' + acc.account_id + '/statement', { statement_balance: Number(v) }).then(load).catch(function (e) {
      alert('บันทึกไม่สำเร็จ: ' + ((e.response && e.response.data && e.response.data.error) || ''));
    });
  }
  if (!data) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;
  var accounts = data.accounts || [];
  return (
    <div style={Object.assign({}, card, { padding: 0, overflowX: 'auto' })}>
      <div style={{ fontSize: 14, fontWeight: 600, padding: '14px 16px 0', color: '#0f172a' }}>ตรวจยอด (ยอดระบบ เทียบ ยอดธนาคารจริง)</div>
      <div style={{ fontSize: 11, color: '#94a3b8', padding: '4px 16px 0' }}>ยอดระบบ = ตั้งต้น + รายรับ − รายจ่าย • diff = ยอดธนาคารจริง − ยอดระบบ (0 = ตรง)</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginTop: 8 }}>
        <thead>
          <tr style={{ background: '#f8fafc' }}>
            {['บัญชี', 'ตั้งต้น', 'รายรับ', 'รายจ่าย', 'ยอดระบบ', 'ยอดธนาคารจริง', 'diff', ''].map(function (h, i) {
              return <th key={i} style={{ padding: '10px 14px', textAlign: i === 0 ? 'left' : 'right', fontSize: 11, color: '#64748b', fontWeight: 600 }}>{h}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {accounts.length === 0 ? <tr><td colSpan="8" style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>ยังไม่มีบัญชี</td></tr> :
            accounts.map(function (a, i) {
              var hasStmt = a.statement_balance !== null && a.statement_balance !== undefined;
              var diffOk = hasStmt && Math.abs(a.diff) < 0.005;
              return (
                <tr key={i} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 500, color: '#0f172a' }}>{a.label}<div style={{ fontSize: 10, color: '#94a3b8' }}>{a.business_name}</div></td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#64748b' }}>{money(a.opening_balance)}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#10b981' }}>{a.income ? money(a.income) : '-'}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#ef4444' }}>{a.expense ? money(a.expense) : '-'}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, color: a.computed >= 0 ? '#0f172a' : '#ef4444' }}>{money(a.computed)}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: hasStmt ? '#0f172a' : '#cbd5e1' }}>{hasStmt ? money(a.statement_balance) : '—'}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 700, color: !hasStmt ? '#cbd5e1' : diffOk ? '#10b981' : '#ef4444' }}>{!hasStmt ? '—' : diffOk ? '✓ ตรง' : money(a.diff)}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right' }}><button onClick={function () { setStatement(a); }} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #e2e8f0', background: 'white', color: '#475569', cursor: 'pointer', fontSize: 11 }}>กรอกยอด</button></td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

// ===== ตาราง pivot ใช้ร่วม =====
function PivotTable(props) {
  var rows = props.rows || [];
  var totalIn = 0, totalOut = 0, totalCount = 0;
  rows.forEach(function (r) { totalIn += r.income; totalOut += r.expense; totalCount += r.count; });
  return (
    <div style={Object.assign({}, card, { padding: 0, overflowX: 'auto' })}>
      <div style={{ fontSize: 14, fontWeight: 600, padding: '14px 16px 0', color: '#0f172a' }}>{props.title}</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginTop: 8 }}>
        <thead>
          <tr style={{ background: '#f8fafc' }}>
            {['รายการ', 'รายรับ', 'รายจ่าย', 'คงเหลือ', 'จำนวน'].map(function (h, i) {
              return <th key={i} style={{ padding: '10px 14px', textAlign: i === 0 ? 'left' : 'right', fontSize: 11, color: '#64748b', fontWeight: 600 }}>{h}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? <tr><td colSpan="5" style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>ยังไม่มีข้อมูล</td></tr> :
            rows.map(function (r, i) {
              return (
                <tr key={i} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 500, color: '#0f172a' }}>{r[props.labelKey]}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#10b981' }}>{r.income ? money(r.income) : '-'}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#ef4444' }}>{r.expense ? money(r.expense) : '-'}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, color: r.balance >= 0 ? '#0f172a' : '#ef4444' }}>{money(r.balance)}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#94a3b8' }}>{r.count}</td>
                </tr>
              );
            })}
        </tbody>
        {rows.length > 0 && (
          <tfoot>
            <tr style={{ borderTop: '2px solid #e2e8f0', background: '#f8fafc', fontWeight: 700 }}>
              <td style={{ padding: '10px 14px', color: '#0f172a' }}>รวม</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', color: '#10b981' }}>{money(totalIn)}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', color: '#ef4444' }}>{money(totalOut)}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', color: (totalIn - totalOut) >= 0 ? '#0f172a' : '#ef4444' }}>{money(totalIn - totalOut)}</td>
              <td style={{ padding: '10px 14px', textAlign: 'right', color: '#64748b' }}>{totalCount}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
